import React from "react";
import { FormGroup, ModalBody, ModalHeader, Input, Label, Button, Form } from "reactstrap";
import SimpleReactValidator from "simple-react-validator";
import { addSubTopic, updateSubTopic} from "../../../services/topicService";
import { notifyError, notifySuccess } from "../../../utils/utils";
import Loader from "../../../utils/Loader";

class AddSubTopic extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            subtopic: "",
            topic_master_id:"",
        };

        this.validator = new SimpleReactValidator({
            locale: 'en', messages:{}, autoForceUpdate: this,
            validators: {
                subtopic: {
                    message: "Sub Topic name contains only Alphabet, Numbers and Symbols ,-'[]()&",
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val,  /^[\w&.,'/\s/g\[\]()\-]+$/)
                    }
                }
            }
        });

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        if(!this.validator.allValid()){
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        const data = { sub_topic_name: this.state.subtopic, topic_master_id: this.state.topic_master_id};
        this.setState({ loading: true });
        if(this.props.isEditing) {
            updateSubTopic(this.state.id, data).then(res => this.handleResponse(res.data))
        } else {
            addSubTopic(data).then(res => this.handleResponse(res.data)); 
        }
    }

    handleResponse(data) {
      
        console.log(data);
        if(data.status) {
            notifySuccess(data.message);
            setTimeout(() => {
                this.props.toggle();
                this.props.reload();
            }, 1000);
        } else {
            this.setState({ loading: false });
            notifyError(data.message);
        }
    }

    componentDidMount(){
        this.setState({
            topicOptions: this.props.topicOptions
        });
        if(this.props.isEditing){   
            this.setState({
                topic_master_id: this.props.subtopic.topic_master_id,
                subtopic: this.props.subtopic.sub_topic_name,
                id: this.props.subtopic.sub_topic_id,     
            });
        }
    }

    render() {
        this.validator.purgeFields();

        const { subtopic, topic_master_id, topicOptions } = this.state;

        return(

            <React.Fragment>
                {/* <div className="page-content">
                    <Container fluid> */}
                        <ModalHeader toggle={() => this.props.toggle()}> 
                            {this.props.isEditing ? "Edit" : "Add"} Sub Topic
                        </ModalHeader>
                        <ModalBody>
                            <Form onSubmit={this.handleSubmit} autoComplete="off">
                                <FormGroup>
                                    <Label>Topic</Label>
                                    <Input
                                        type="select"
                                        name="topic_master_id"
                                        value={topic_master_id}
                                        onChange={e => {
                                            this.setState({
                                                topic_master_id: e.target.value
                                            });
                                        }}
                                    >
                                        <option value="">Select</option>
                                        {topicOptions && topicOptions.map((x,i) =>
                                            <option key={i} value={x.topic_id}>{x.topic_name}</option>
                                        )}
                                    </Input>
                                    <span className="text-danger">
                                        {this.validator.message('topic', topic_master_id, 'required')}
                                    </span>
                                </FormGroup>
                                

                                <FormGroup>
                                    <Label>Sub Topic</Label>
                                    <Input
                                        type="text"
                                        name="subtopic"
                                        value={subtopic}
                                        onChange={e => {
                                            this.setState({
                                                subtopic: e.target.value
                                            });
                                        }}
                                    />
                                    <span className="text-danger"> 
                                    {
                                        //alpha_num_space|
                                    }
                                        {this.validator.message('sub topic name', subtopic, 'required|min:2|max:30|subtopic')}
                                    </span>
                                </FormGroup>

                                <FormGroup className="pull-right">
                                {
                                    this.state.loading
                                        ?
                                            <Loader />
                                        :
                                            <Button color="success" type="submit">Submit</Button> 
                                }
                                </FormGroup>
                            </Form>
                        </ModalBody>
                    {/* </Container>
                </div> */}
            </React.Fragment>
        )
    }
}

export default AddSubTopic;